"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const __1 = require("../..");
const react_1 = require("react");
const SearchInput = ({ onPressEnter, initialQuery = onPressEnter, initialValue, urlSearchParamName = 'q', searchIcon, align = 'center', size = 6, }) => {
    const [query, setQuery] = react_1.useState((initialValue !== null && initialValue !== void 0 ? initialValue : (urlSearchParamName && new URLSearchParams(location.search).get(urlSearchParamName))) || '');
    const osSubmit = (event) => {
        event.preventDefault();
        onPressEnter(query);
        if (urlSearchParamName) {
            const newURL = new URL(location.href);
            if (query)
                newURL.searchParams.set(urlSearchParamName, query);
            else
                newURL.searchParams.delete(urlSearchParamName);
            history.replaceState({}, '', newURL.href);
        }
    };
    const gridSizes = react_1.useMemo(() => {
        const getGridSize = (grid) => Math.max(Math.min(Math.round(grid), 12), 1);
        return `p-col-${getGridSize(size * 2)} p-md-${getGridSize(size)} p-lg-${getGridSize(size / 2)}`;
    }, [size]);
    react_1.useEffect(() => { initialQuery(query); }, []);
    return (jsx_runtime_1.jsx("form", Object.assign({ onSubmit: osSubmit, className: `p-grid p-justify-${align}` }, { children: jsx_runtime_1.jsxs("div", Object.assign({ className: `${gridSizes} p-my-3` }, { children: [jsx_runtime_1.jsxs("span", Object.assign({ className: "p-input-icon-left p-d-block p-fluid" }, { children: [searchIcon, jsx_runtime_1.jsx(__1.InputText, { value: query, type: "search", className: "ui-fluid", placeholder: "Filtrar", onChange: (e) => setQuery(e.currentTarget.value) }, void 0)] }), void 0),
                jsx_runtime_1.jsx("small", Object.assign({ className: "p-text-right p-d-block" }, { children: "Pressione Enter para pesquisar." }), void 0)] }), void 0) }), void 0));
};
exports.default = SearchInput;
//# sourceMappingURL=index.js.map